// extracted by mini-css-extract-plugin
module.exports = {"label":"_1Q72N93IdSx4h7jZlUBTZ_"};